// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header_container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 2rem;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  position: sticky;
  top: 0;
  z-index: 1000;
}

.logo {
  height: 50px;
  width: auto;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
  transition: transform 0.2s ease;
}

.logo:hover {
  transform: scale(1.05);
}

.user-section {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.greeting {
  color: white;
  font-size: 0.95rem;
  font-weight: 400;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
  line-height: 1.4;
}

.greeting strong {
  font-weight: 600;
  color: #f8f9fa;
}

.greeting em {
  font-style: normal;
  background: rgba(255, 255, 255, 0.2);
  padding: 0.25rem 0.5rem;
  border-radius: 6px;
  font-weight: 500;
  backdrop-filter: blur(10px);
}

.signout-button {
  background: rgba(255, 255, 255, 0.15);
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.3);
  padding: 0.6rem 1.2rem;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 500;
  font-size: 0.9rem;
  transition: all 0.2s ease;
  backdrop-filter: blur(10px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.signout-button:hover {
  background: rgba(255, 255, 255, 0.25);
  border-color: rgba(255, 255, 255, 0.5);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.signout-button:active {
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* Responsive design */
@media (max-width: 768px) {
  .header_container {
    padding: 1rem;
    flex-direction: column;
    gap: 1rem;
  }
  
  .user-section {
    flex-direction: column;
    gap: 0.75rem;
    text-align: center;
  }
  
  .greeting {
    font-size: 0.9rem;
  }
  
  .logo {
    height: 40px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/header.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,6DAA6D;EAC7D,0CAA0C;EAC1C,gBAAgB;EAChB,MAAM;EACN,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iDAAiD;EACjD,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,qCAAqC;EACrC,YAAY;EACZ,0CAA0C;EAC1C,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;EACtC,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,wBAAwB;EACxB,wCAAwC;AAC1C;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;EACd;AACF","sourcesContent":[".header_container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1rem 2rem;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  position: sticky;\n  top: 0;\n  z-index: 1000;\n}\n\n.logo {\n  height: 50px;\n  width: auto;\n  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));\n  transition: transform 0.2s ease;\n}\n\n.logo:hover {\n  transform: scale(1.05);\n}\n\n.user-section {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.greeting {\n  color: white;\n  font-size: 0.95rem;\n  font-weight: 400;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);\n  line-height: 1.4;\n}\n\n.greeting strong {\n  font-weight: 600;\n  color: #f8f9fa;\n}\n\n.greeting em {\n  font-style: normal;\n  background: rgba(255, 255, 255, 0.2);\n  padding: 0.25rem 0.5rem;\n  border-radius: 6px;\n  font-weight: 500;\n  backdrop-filter: blur(10px);\n}\n\n.signout-button {\n  background: rgba(255, 255, 255, 0.15);\n  color: white;\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  padding: 0.6rem 1.2rem;\n  border-radius: 8px;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 0.9rem;\n  transition: all 0.2s ease;\n  backdrop-filter: blur(10px);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.signout-button:hover {\n  background: rgba(255, 255, 255, 0.25);\n  border-color: rgba(255, 255, 255, 0.5);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n}\n\n.signout-button:active {\n  transform: translateY(0);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .header_container {\n    padding: 1rem;\n    flex-direction: column;\n    gap: 1rem;\n  }\n  \n  .user-section {\n    flex-direction: column;\n    gap: 0.75rem;\n    text-align: center;\n  }\n  \n  .greeting {\n    font-size: 0.9rem;\n  }\n  \n  .logo {\n    height: 40px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
